export { Layout2 } from "./Layout2";

